// extracted by mini-css-extract-plugin
export default {"infogrid":"dashboard_infogrid__MO8yU","profile":"dashboard_profile__ECpx7","frmdata":"dashboard_frmdata__zEBNR","table":"dashboard_table__0h8sx"};